/**
 * Brazilian Portuguese (pt-BR) mappings for Football Mobile Dashboard
 * Mobile-specific translations for football components
 */

export const footballMobilePtBR = {
  // Header
  "Football": "Futebol",
  "Live scores & stats": "Placar ao vivo e estatísticas",
  
  // Beta Notice
  "All AI picks saved to chat history": "Todas as apostas da IA salvas no histórico do chat",
  "Go to chat to dive deeper": "Vá para o chat para se aprofundar",
  "Not all features available yet": "Nem todos os recursos disponíveis ainda",
  "v3-Beta: Not all features available yet": "v3-Beta: Nem todos os recursos disponíveis ainda",
  
  // Tabs
  "Live": "Ao Vivo",
  "Tables": "Tabelas",
  "Players": "Jogadores",
  
  // Status
  "LIVE": "AO VIVO",
  "Final": "Final",
  "TBD": "A definir",
  
  // Empty States
  "No fixtures found": "Nenhum jogo encontrado",
  "Try selecting a different date": "Tente selecionar uma data diferente",
  "Select a league": "Selecione uma liga",
  "Choose a league from filters to view standings": "Escolha uma liga nos filtros para ver a classificação",
  "Choose a league from filters to view top scorers": "Escolha uma liga nos filtros para ver os artilheiros",
  "Failed to load fixtures": "Falha ao carregar jogos",
  "Failed to load players": "Falha ao carregar jogadores",
  "Try Again": "Tentar Novamente",
  
  // Loading
  "Loading fixtures...": "Carregando jogos...",
  "Loading players...": "Carregando jogadores...",
  
  // Filters
  "Filters": "Filtros",
  "Date": "Data",
  "Country": "País",
  "League": "Liga",
  "Season": "Temporada",
  "All Countries": "Todos os Países",
  "All Leagues": "Todas as Ligas",
  "Select League": "Selecionar Liga",
  "Select Season": "Selecionar Temporada",
  "Apply Filters": "Aplicar Filtros",
  
  // League Toggle
  "🌍 All Leagues (103)": "🌍 Todas as Ligas (103)",
  "⭐ Top Leagues": "⭐ Principais Ligas",
  
  // Pagination
  "Previous": "Anterior",
  "Next": "Próximo",
  
  // Odds Sheet
  "Betting Odds": "Cotações de Apostas",
  "No odds available": "Sem cotações disponíveis",
  "Odds data not available for this match": "Dados de cotações não disponíveis para esta partida",
  "No odds data": "Sem dados de cotações",
  "No betting odds available for this match": "Sem cotações de apostas disponíveis para esta partida",
  
  // Prediction
  "AI Pick": "Escolha da IA",
  "Analyzing...": "Analisando...",
  
  // Standings Table
  "Team": "Time",
  "P": "J",  // Partidas/Jogos
  "W": "V",  // Vitórias
  "D": "E",  // Empates
  "L": "D",  // Derrotas
  "GF": "GP", // Gols Pró
  "GA": "GC", // Gols Contra
  "GD": "SG", // Saldo de Gols
  "Pts": "Pts", // Pontos
  "Form": "Forma",
  
  // Player Card
  "Goals": "Gols",
  "Assists": "Assistências",
  "Apps": "Jogos",
  "Rating": "Nota",
  "G/A": "G/A",
  
  // Mobile Prediction Bar
  "Game Selected (Max 5)": "Jogo Selecionado (Máx 5)",
  "Games Selected (Max 5)": "Jogos Selecionados (Máx 5)",
  "7 coins/game": "7 moedas/jogo",
  "coins total": "moedas total",
  "Predict Winners": "Prever Vencedores",
  "Predicting...": "Prevendo...",
  "Insufficient Star Coins. Need": "Moedas Estrela insuficientes. Precisa de",
  "coins.": "moedas.",
  
  // Time
  "ET": "ET",
  "Today": "Hoje",
  "Tomorrow": "Amanhã",
  "Yesterday": "Ontem",
  
  // Close/Back
  "Close": "Fechar",

  // Chat CTA
  "Analyze in Chat": "Analisar no Chat",
  "More in Chat": "Mais no Chat",

  // Upgrade Notice
  "Upgrade to Premium": "Atualizar para Premium",
  "Get unlimited predictions": "Obtenha previsões ilimitadas"
};